import { GeoService } from "./GeoService";

export class GeographicalService implements GeoService.MapSource {
  /**
   * GeographicalService Class is a bridge between the UI Component & ThirdParty Geographical Service Class
   * Below Methods are only interacting with the Interfaces to call the Services
   */
  private static instance: GeographicalService;
  private source: GeoService.MapSource;
  constructor() {
    this.source = {} as GeoService.MapSource;
  }

  public static get details(): GeographicalService {
    if (!GeographicalService.instance) {
      GeographicalService.instance = new GeographicalService();
    }
    return GeographicalService.instance;
  }

  public setSource(source: GeoService.MapSource) {
    this.source = source;
  }
  public renderMap(
    isLimitedZoom: boolean,
    container: GeoService.Container,
    bounds: GeoService.Bounds,
    style: string,
    fitBoundsOptions?: GeoService.FitBoundsOptions
  ) {
    return this.source.renderMap(
      isLimitedZoom,
      container,
      bounds,
      style,
      fitBoundsOptions
    );
  }
  public createBounds(sw: GeoService.Sw, ne: GeoService.Ne) {
    return this.source.createBounds(sw, ne);
  }
  public renderRoute(
    routeId: string,
    stops: GeoService.Stops,
    frameOptions: GeoService.FitBoundsOptions
  ) {
    return this.source.renderRoute(routeId, stops, frameOptions);
  }
  public renderMarker(svgContent: HTMLElement, lng: number, lat: number) {
    return this.source.renderMarker(svgContent, lng, lat);
  }
  public renderPopup(options: GeoService.PopupOptions) {
    return this.source.renderPopup(options);
  }
  public renderFullscreenControl() {
    return this.source.renderFullscreenControl();
  }
  public renderExpandCollapseControl(
    isDialog: boolean,
    onExpand: Function,
    onCollapse: Function
  ) {
    return this.source.renderExpandCollapseControl(
      isDialog,
      onExpand,
      onCollapse
    );
  }
  public async getCoordinates(location: GeoService.Location) {
    return this.source.getCoordinates(location);
  }
  public async getLongitudeLatitude(lng: number, lat: number) {
    return this.source.getLongitudeLatitude(lng, lat);
  }
  public destroy() {
    return this.source.destroy();
  }
  public navControl(options: GeoService.NavigationControlOptions) {
    return this.source.navControl(options);
  }
  public getStopMarker(index: number, stopLength: number, stopType: string) {
    return this.source.getStopMarker(index, stopLength, stopType);
  }

  public async searchCurrentAddress(
    query: string,
    getAddress: GeoService.GetAddressFunction
  ) {
    return await this.source.searchCurrentAddress(query, getAddress);
  }
  public async searchAddress(
    query: string,
    getAddress: GeoService.GetAddressFunction
  ) {
    return await this.source.searchAddress(query, getAddress);
  }
}
